import type { ReactNode } from "react";

import type { HaNFloorSuggestion, HaNNodeSelection } from "@lib/logic";

import { FloorSuggestionTile } from "../../FloorSuggestionTile";
import { HaNResultList } from "../../HaNResultList/HaNResultList";
import type { HaNResult } from "../../useOpenResult";
import { useOpenSuggestedResult } from "../../useOpenSuggestedResult";

type FloorSuggestionGroupProps<Item extends HaNResult> = {
  kind: HaNNodeSelection["kind"];
  suggestion: HaNFloorSuggestion<Item>;
  direction: "above" | "below";
  renderCell: (item: Item) => ReactNode;
};

// A floor's suggestions, under its tile
export const FloorSuggestionGroup = <Item extends HaNResult>({
  kind,
  suggestion,
  direction,
  renderCell,
}: FloorSuggestionGroupProps<Item>) => {
  const openSuggestedResult = useOpenSuggestedResult();

  return (
    <FloorSuggestionTile
      floorId={suggestion.floorId}
      direction={direction}>
      <HaNResultList>
        {suggestion.items.map(item => (
          <HaNResultList.Item
            key={item.id}
            nodeId={item.id}
            onSelect={() => openSuggestedResult(kind, item, direction)}>
            {renderCell(item)}
          </HaNResultList.Item>
        ))}
      </HaNResultList>
    </FloorSuggestionTile>
  );
};
